import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';

import * as actions from './actions';

const state = createGenericFetchMachine<string>();

export { state, actions };
